module.exports = __webpack_public_path__ + "img/orders40.3eb40cfc.png";